<template>
  <div class="GlobalTable">
    <GlobalTable ref="GlobalTable" v-loading="loading" :columns="tableColumns" :data="this.seachDataList"
      :currentPage="page.pageNum" :total="this.page.total" @handleCurrentChange="handleCurrentChange">
      <el-table-column label="区域" slot="areaName" align="center">
        <template slot-scope="{ row }">
          <span>{{ row.areaName || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="店长" slot="storeMana" align="center">
        <template slot-scope="{ row }">
          <span v-if="row.storeManager">{{
            row.storeManager
          }}</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column label="联系电话" slot="storeMana" align="center">
        <template slot-scope="{ row }">
          <span v-if="row.storeManagerPhone">{{
            row.storeManagerPhone
          }}</span>
          <span v-else>--</span>
        </template>
      </el-table-column>

      <el-table-column label="门店营业时间" slot="operationImg" align="center">
        <template slot-scope="{ row }">
          <span v-if="row.startTime">{{
            row.startTime + "~" + row.endTime
          }}</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column label="门店地址" slot="storeAddress" align="center">
        <template slot-scope="{ row }">
          <span v-if="row.storeAddress">{{ row.storeAddress }}</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column label="门店封面图" slot="storeImg" align="center">
        <template slot-scope="{ row }">
          <img v-if="row.coverPicture" :src="row.coverPicture" style="width: 70px;height:70px; cursor: pointer;" alt=""
            @click="seeSampleImage(row)" />
          <span v-else>暂无数据</span>
        </template>
      </el-table-column>
      <el-table-column label="门店详情照片" slot="storedetleImg" align="center">
        <template slot-scope="{ row }">
          <span v-if="row.infoImg" style="color:#0981FF; cursor: pointer;" @click="staffDia(row)">{{
            "共" + row.infoImg.split(",").length + "张"
          }}</span>
          <span v-else>暂无数据</span>
        </template>
      </el-table-column>
      <el-table-column label="店长微信" slot="shopmanager" align="center">
        <template slot-scope="{ row }">
          <div class="wechatAction">
            <el-button size="mini" type="text" round @click="editBtn(row, 'price')">
              {{ !row.storeManagerWechatCode && !row.storeManagerWechatQrcode ? '添加' : '修改' }}
            </el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="线上启用状态" slot="operationSex" align="center">
        <template slot-scope="{ row }">
          <el-switch inactive-color="#bebebe" @change="handleSwitch(row, 'switch')"
            v-model="row.isOnlineEnable"></el-switch>
        </template>
      </el-table-column>
      <el-table-column width="200" label="操作" slot="operation" align="center">
        <template slot-scope="{ row }">
          <el-button size="mini" type="primary" round @click="handleBtn(row, 'edit')">编辑</el-button>
        </template>
      </el-table-column>
    </GlobalTable>
    <!-- 二维码弹窗 -->

    <el-dialog title="添加报价设置" :visible.sync="DialogCode" :close-on-click-modal="false" width="500px"
      @closed="DialogCode = false">
      <div class="qustion-top widQus" style="margin-top:0">
        <div><img src="@/assets/images/imgAll/ico_ts_red@2x.png" alt /></div>
        <div>扫码小程序进入报价设置页面，添加/修改报价设置</div>
      </div>
      <div class="img_code">
        <img src="@/assets/images/imgAll/ico_ts_red@2x.png" alt />
      </div>
      <div style="float:right;margin-bottom:10px">
        <el-button @click="DialogCode = false">关闭</el-button>
      </div>
    </el-dialog>
    <!-- 报价设置弹窗 -->
    <el-dialog title="查看报价设置" :visible.sync="dialogQuotatVisible" :close-on-click-modal="false" width="600px"
      @closed="dialogQuotatVisible = false">
      <div class="qustion-top widQus" style="margin-top:0">
        <div><img src="@/assets/images/ico_ts_red.png" alt /></div>
        <div>
          报价设置仅限于对外显示，避免顾客看到真实价格，员工提成以原价计算
        </div>
      </div>
      <!-- <div class="widQus">
        <el-button type="primary" size="mini" @click="AddQustion" icon="el-icon-plus">添加报价设置</el-button>
      </div> -->
      <div class="box-qustion widQus" v-if="this.quoteList.length > 0">
        <div class="qustion-item flex" v-for="item in quoteList" :key="item">
          <div class="left flex">
            <div class="text">报价区间</div>
            <div class="btn">
              <el-input v-model="item.startQuote" :disabled="true" class="el_input_item"></el-input>
              ~
              <el-input v-model="item.endQuote" :disabled="true" class="el_input_item"></el-input>
            </div>
          </div>
          <div class="right flex">
            <div class="text">报价比例</div>
            <el-input v-model="item.quoteRatio" :disabled="true" class="el_input_item"></el-input>%
          </div>
        </div>
      </div>
      <div class="none-Data" v-else>
        暂无数据
      </div>
    </el-dialog>
    <!--添加编辑弹框-->
    <el-dialog class="add-store" :title="`${storeDiaTitle}` + '提示'" :visible.sync="dialogStoreVisible"
      :close-on-click-modal="false" width="500px" @closed="closeDialogStore">
      <p>{{ centerCon }}</p>
      <!-- v-if="!titleShow" -->
      <!-- <p v-else></p> -->
      <span slot="footer" class="dialog-footer">
        <el-button v-if="butShow" type="primary" @click.stop="handleSuccess">确定</el-button>
        <el-button @click.native="closeDialogStore">取消</el-button>
      </span>
    </el-dialog>
    <DialogTbale @onClose="onClose" :show="staffVisible" title="店员列表" :columns="DialogTableColumns" :data="DialogDataList"
      :currentPage="pageNum" :total="total" :pageSize="pageSize" :width="1210"
      @handleCurrentChange="handleCurrentChangeDialog">
      <div style="margin-bottom:20px;display:flex">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="姓名">
            <el-input v-model="formInline.staffName" placeholder="请输入店员姓名" class="form_input"></el-input>
          </el-form-item>
          <el-form-item label="电话">
            <el-input v-model="formInline.staffMobile" placeholder="请输入店员电话" class="form_input"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getStaffList(1)" size="mini">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-table-column label="职位" slot="staffType" align="center">
        <template slot-scope="{ row }">
          <span v-if="row.staffType == '02'">总监</span>
          <span v-else-if="row.staffType == '03'">门店店长</span>
          <span v-else-if="row.staffType == '04'">普通职员</span>
        </template>
      </el-table-column>
    </DialogTbale>
    <el-dialog :close-on-click-modal="false" :width="`${800}px`" title="查看门店封面图" :visible="imgShow" @close="imgClose"
      top="5%">
      <div class="img-box">
        <div class="img-tips-box">
          <div class="img-tips" :class="imgShowOnly ? 'img-tips-choose' : 'img-tips-default'">
            门店封面图
          </div>
        </div>
        <div class="img-show">
          <div class="imgs-num" v-if="DialogImgList.length > 0">
            {{ imgShowIndex + 1 }}/{{ DialogImgList.length }}
          </div>
          <div class="block">
            <viewer :images="DialogImgList">
              <el-carousel trigger="click" height="80vh" @change="getindex">
                <el-carousel-item v-for="(item, index) in this.DialogImgList" :key="index">
                  <div class="sec_img">
                    <img :src="item" alt="" />
                  </div>
                </el-carousel-item>
              </el-carousel>
            </viewer>
          </div>
          <!-- <LookImg :images="imgList"/> -->
        </div>
      </div>
    </el-dialog>
    <!--店长微信弹框-->
    <el-dialog class="add-form" title="设置店长微信" :visible.sync="addShow" :close-on-click-modal="false" width="520px"
      @closed="resetForm('ruleForm')">
      <div class="wechaStitle">
        <p>说明：设置店长微信二维码，建议使用企业微信二维码 </p>
        <div class="wechatAction">
          <el-button size="mini" type="text" round @click="haveImage('https://img.fanxinghuishou.cn/20230814/553144743.png')">
            查看示例
          </el-button>
        </div>
      </div>
      <el-form :model="formDataDialog" :rules="formRulesDialog" ref="ruleForm" label-width="106px">
        <!-- <el-form-item label="微信号" prop="wechatCode">
          <el-input :maxlength="20" v-model="formDataDialog.wechatCode" placeholder="请输入微信号，最多20位" clearable>
          </el-input>
        </el-form-item> -->
        <el-form-item label="微信二维码" prop="wechatQrcode">
          <ElImgUpload :exist-image="formDataDialog.wechatQrcode" @handleDelete="handleUploadDelete"
            @handleChange="handleUploadChange($event)" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="resetForm('ruleForm')">取 消</el-button>
        <el-button size="small" type="primary" :loading="btnLoading" @click="submitAdd('ruleForm')">确认</el-button>
      </span>
    </el-dialog>
    <el-image-viewer :z-index="10000" v-if="showViewer" :on-close="() => {
        showViewer = false;
      }
      " :url-list="imgList" />
  </div>
</template>

<script>
import MinXinRequest from "@/mixins/request";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import ElImgUpload from "../../../components/global/components/elements/upload-element.vue";
import _api from "@/utils/request";
import { http } from "../../../utils/request/newIndex";
export default {
  name: "Table",
  components: { ElImageViewer, ElImgUpload },
  mixins: [MinXinRequest],
  data() {
    return {
      addShow: false,
      formDataDialog: {
        "wechatQrcode": "",//二维码
        "wechatCode": ""//微信号
      },
      formRulesDialog: {
        // wechatCode: [
        //   {
        //     required: true,
        //     trigger: "blur",
        //     message: "门店店长微信号不能为空",
        //   },
        // ],
        wechatQrcode: [
          {
            required: true,
            trigger: "blur",
            message: "门店店长微信二维码不能为空",
          },
        ],
      },
      // 店员弹窗
      formInline: {
        staffName: "",
        staffMobile: "",
      },
      imgList: [],
      storeId: "",
      staffVisible: false,
      btnLoading: false,
      total: 0,
      pageNum: 1,
      pageSize: 10,
      imgShow: false,
      imgShowOnly: true,
      DialogImgList: [],
      imgShowIndex: 0,
      imgIndex: 0,
      DialogDataList: [],
      DialogTableColumns: [
        { label: "店员姓名", prop: "staffName" },
        { slotName: "staffType" },
        { label: "联系电话", prop: "staffMobile" },
      ],
      //////////列表
      seachDataList: [],
      //弹窗
      dialogVisible: false, // 弹框的出现与否
      ////////
      tableColumns: [
        { slotName: "areaName" },
        { label: "门店名称", prop: "storeName" },
        // { label: "店长", prop: "storeManager" },
        // { slotName: "storeCode" },
        { slotName: "storeMana" },
        // { label: "联系电话", prop: "storeManagerPhone" },
        { slotName: "operationImg" },
        { slotName: "storeAddress" },
        { slotName: "storeImg" },
        { slotName: "storedetleImg" },
        // { label: "门店地址", prop: "storeAddress" },
        // { label: "添加时间", prop: "createTime" },
        { slotName: "shopmanager" },
        { slotName: "operationSex" },
        { slotName: "operation" },
      ],
      // 添加编辑门店弹窗
      editId: "",
      titleShow: false,
      showViewer: false,
      storeDiaTitle: "",
      ruleForm: {
        storeName: "",
        storeCode: "",
        storeAddress: "",
        merchantIds: [],
      },
      rules: {
        storeName: [
          { required: true, message: "请输入门店名称", trigger: "change" },
        ],
        storeAddress: [
          { required: true, message: "请输入门店地址", trigger: "change" },
        ]
      },
      dialogTitle: "",
      dialogStoreVisible: false,
      //////////////报价设置弹窗
      dialogQuotatVisible: false,
      quoteList: [], //报价弹窗数组
      DialogCode: false,
      merchantList: [],
      changeisEnabl: {},
      centerCon: "",
      butShow: true,
      rowId: ""
    };
  },
  computed: {
    SeachParams() {
      return this.$store.state.tagsView.SeachParams;
    },
    storeAddEdit() {
      return this.$store.state.tagsView.storeAddEdit;
    },
    storeExcel() {
      return this.$store.state.tagsView.storeExcel;
    },
  },
  created() {
    // this.findInquiryMerchantEnable();
    this.handleCurrentChange(1);
  },
  watch: {
    SeachParams(newVal) {
      console.log(newVal);
      this.handleCurrentChange();
    },
    // storeAddEdit(newVal) {
    //   if (newVal === "add") {
    //     this.selectAll()
    //     this.storeDiaTitle = "添加";
    //     this.dialogStoreVisible = true;
    //     this.ruleForm.storeAddress = "";
    //     this.ruleForm.storeCode = "";
    //     this.ruleForm.storeName = "";
    //   } else {
    //     this.storeDiaTitle = "编辑";
    //   }
    // },
    storeExcel(newVal) {
      console.log(newVal, "storeExcel");
      if (newVal == "storeExcel") {
        this.handleCurrentChange(1);
      }
    },
    dialogStoreVisible(newVal) {
      if (newVal === false) {
        this.$store.commit("tagsView/STORE_ADDEDIT", "edit");
      }
    },
  },
  methods: {
    // 店长微信账号确认添加
    submitAdd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          if(!this.rowId){
            this.$message.error('请添加门店店长！');
            return
          }
          _api.saveStaffWechatCode({ staffId: this.rowId, ...this.formDataDialog }).then(res => {
            if (res.code === 1) {
              this.addShow = false
              this.$message({
                message: '添加成功！',
                type: 'success'
              });
              this.handleCurrentChange(1);
              this.formDataDialog = {
                "wechatQrcode": "",//二维码
                "wechatCode": ""//微信号
              }
            }
            this.btnLoading = false
          }).catch(err => {
            this.btnLoading = false
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });

    },
    //删除图片
    handleUploadDelete() {
      this.formDataDialog.wechatQrcode = "";
    },
    // 上传图片后，将图片信息保存到对应参数中
    handleUploadChange(url) {
      this.formDataDialog.wechatQrcode = url;
    },
    //店长微信账号弹窗关闭
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.addShow = false
      this.formDataDialog = {
        "wechatQrcode": "",//二维码
        "wechatCode": ""//微信号
      }
    },
    // 查看示例图大图
    seeSampleImage(row) {
      if (row.coverPicture) {
        this.imgList = [];
        this.showViewer = true;
        this.imgList.push(row.coverPicture);
      }
    },
    // 查看示例图大图
    haveImage(row) {
      if (row) {
        this.imgList = [];
        this.showViewer = true;
        this.imgList.push(row);
      }
    },
    getindex(e) {
      console.log(e);
      this.imgShowIndex = e;
    },
    imgClose() {
      console.log(1);
      this.imgShow = false;
      this.imgList = [];
    },
    // 表格切换页面
    handleCurrentChange(val) {
      console.log(val);
      const baseRequest = {
        storeManager: this.SeachParams.storeManager,
        storeManagerPhone: this.SeachParams.staffMobile,
        storeName: this.SeachParams.storeName,
        pageNum: val ? val : this.SeachParams.pageNum,
        areaId: this.SeachParams.areaId,
        pageSize: 10,
      };
      http.getstoreList(baseRequest).then((res) => {
        if (res.code === 1) {
          console.log(res);
          this.seachDataList = res.data.records;
          this.page.total = res.data.total;
          this.page.pageNum = res.data.current;
          this.$store.commit("tagsView/POST_STAFF", this.seachDataList);
          this.$store.commit("tagsView/STORE_EXCEL", "false");
        }
        if (typeof this.SeachParams.disuseLoding === 'function') {
          this.SeachParams.disuseLoding();
        }
      }).catch(() => {
        if (typeof this.SeachParams.disuseLoding === 'function') {
          this.SeachParams.disuseLoding();
        }
      });
    },
    //
    editBtn(row) {
      this.rowId = row.storeManagerId;
      this.addShow = true;
      if (row.storeManagerWechatQrcode) {
        this.formDataDialog.wechatQrcode = row.storeManagerWechatQrcode
        this.formDataDialog.wechatCode = row.storeManagerWechatCode
      }
    },
    // 表格按钮操作
    handleBtn(row, type) {
      console.log("表格操作", type, row);
      if (type == "edit") {
        this.ruleForm.storeAddress = row.storeAddress;
        this.ruleForm.storeCode = row.storeCode;
        this.ruleForm.storeName = row.storeName;
        this.ruleForm.merchantIds = row.merchantIds;
        this.editId = row.id;
        this.addEdit = type;
        // this.storeDiaTitle = "编辑";
        // this.dialogStoreVisible = true;
        this.$router.push({ path: "addStore", query: { id: this.editId } })
        // this.changeSelect(row.merchantIds)
      } else if (type == "price") {
        this.storeId = row.id;
        this.dialogQuotatVisible = true;
        this.PostQuoteConfig();
      }
    },
    //启用/禁用账号
    handleSwitch(row) {
      console.log(row);
      this.butShow = true;
      this.changeisEnabl = {
        id: row.id,
        status: row.isOnlineEnable
      }
      console.log(this.changeisEnabl);
      this.titleShow = row.isOnlineEnable
      if (!this.titleShow) {
        this.storeDiaTitle = "关闭";
        this.dialogStoreVisible = true;
        this.centerCon = "关闭后，线上回收时该门店则不向客户推荐"
        console.log(row);
      } else {
        this.storeDiaTitle = "启用";
        this.dialogStoreVisible = true;
        this.centerCon = `确认已核对【营业时间】,【地址】,【门店照片】,【门店详情照片】等信息无误`;
        console.log(row);
      }

    },
    //弹窗取消
    handleDialogClosed() {
      // this.dialogVisible = false;
    },
    handleCurrentChangeDialog(val) {
      console.log(val);
      this.pageNum = val;
      this.getStaffList(val);
    },
    //查看店员
    staffDia(row) {
      if (row.infoImg) {
        this.imgShow = true;
        this.DialogImgList = row.infoImg.split(",");
        console.log(this.DialogImgList);
      }
    },
    getStaffList(val) {
      console.log(val);
      const params = {
        pageSize: this.pageSize,
        pageNum: val ? val : this.pageNum,
        storeId: this.storeId,
        staffName: this.formInline.staffName,
        staffMobile: this.formInline.staffMobile,
      };
      _api.getStaffList(params).then((res) => {
        console.log(res);
        this.DialogDataList = res.data.records;
        this.total = res.data.total;
      });
    },
    onClose() {
      this.staffVisible = false;
    },
    closeDialogStore() {
      this.dialogStoreVisible = false;
      this.handleCurrentChange()
    },
    ///////////////////添加编辑门店弹窗
    handleStoreClosed() {
      this.dialogStoreVisible = false;
    },
    handleSuccess(formName) {
      http.updateOnlineEnable(this.changeisEnabl).then((res) => {
        console.log(res);
        if (res.code == 1) {
          this.dialogStoreVisible = false;
          this.$message.success(res.msg);
        } else {
          console.log(11111111111);
          this.butShow = false
          this.storeDiaTitle = "启用";
          this.dialogStoreVisible = false;
          this.$message.error(res.msg);
        }
        this.handleCurrentChange();
      }).catch((err) => {
        console.log(222222);
        this.butShow = false
        this.dialogStoreVisible = false;
      });
    },
    //////标价设置弹窗
    PostQuoteConfig() {
      const params = {
        pageNum: 1,
        pageSize: 10,
        storeId: this.storeId,
      };
      _api.quoteConfigList(params).then((res) => {
        console.log(res);
        this.quoteList = res.data.records;
        console.log(this.quoteList, "this.quoteList");
      });
    },
    ///查看二维码
    AddQustion() {
      this.DialogCode = true;
    },
    findInquiryMerchantEnable() {
      _api.findInquiryMerchantEnable().then((res) => {
        console.log(res);
        this.merchantList = res.data;
      });
    },
    selectAll() {
      if (this.ruleForm.merchantIds.length < this.merchantList.length) {
        this.ruleForm.merchantIds = [];
        this.merchantList.map((item) => {
          this.ruleForm.merchantIds.push(item.merchantId);
        });
        this.ruleForm.merchantIds.unshift("全部选择");
      } else {
        this.ruleForm.merchantIds = [];
      }
    },

    changeSelect(val) {
      console.log(val);
      if (!val || !val.length) {
        this.ruleForm.merchantIds = []
        return
      }
      if (!val.includes("全部选择") && val.length === this.merchantList.length) {
        this.ruleForm.merchantIds.unshift("全部选择");
      } else if (val.includes("全部选择") && val.length - 1 < this.merchantList.length) {
        this.ruleForm.merchantIds = this.ruleForm.merchantIds.filter((item) => {
          return item !== "全部选择";
        });
      }
      console.log(this.ruleForm.merchantIds);
    },
    removeTag(val) {
      if (val === "全部选择") {
        this.ruleForm.merchantIds = [];
      }
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.GlobalTable {
  /deep/ .form_input .el-input__inner {
    height: 30px !important;
  }

  .widQus {
    width: 96%;
    margin: 15px auto;
  }

  .qustion-top {
    display: flex;
    align-items: center;
    height: 20px;
    margin-bottom: 15px;

    img {
      width: 18px;
      object-fit: contain;
      margin-right: 5px;
    }

    div {
      font-size: 14px;
      font-family: FZLanTingHei-M-GBK;
      font-weight: 400;
      color: #ff687b;
      line-height: 0px;
    }
  }

  .box-qustion {
    // min-height: 276px;
    max-height: 400px;
    overflow: hidden;
    overflow-y: scroll;
    background: #f5f5f5;
    border-radius: 4px;
  }

  .flex {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .qustion-item {
    padding-bottom: 10px;

    .el_input_item {
      width: 100px !important;
    }

    /deep/ .el-input__inner {
      height: 35px !important;
    }

    .left {
      margin: 20px 50px 0 10px;
    }

    .right {
      margin: 20px 10px 0 0;
    }

    .text {
      margin-right: 5px;
    }
  }

  .img_code {
    width: 200px;
    height: 200px;
    margin: 20px auto;

    img {
      width: 100%;
      object-fit: contain;
    }
  }

  /*修改滚动条样式*/
  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  ::-webkit-scrollbar-track-piece {
    background-color: rgba(0, 0, 0, 0.2);
    -webkit-border-radius: 6px;
    width: 8px;
    background: white;
  }

  ::-webkit-scrollbar-thumb:vertical {
    height: 5px;
    width: 5px;
    background-color: #0981ff;
    -webkit-border-radius: 6px;
  }

  ::-webkit-scrollbar-thumb:horizontal {
    width: 5px;
    background-color: #0981ff;
    -webkit-border-radius: 6px;
    -webkit-border-radius: 6px;
  }

  .none-Data {
    width: 100%;
    height: 100px;
    text-align: center;
    line-height: 100px;
    font-size: 22px;
    color: #666;
  }

  /deep/.el-dialog__body {
    width: 100%;

    >p {
      margin: 30px 0;
      font-size: 17px;
    }
  }

  /deep/.add-store .el-tag.el-tag--info {
    background-color: #fbfbfb;
    border-color: #cecdcd;
    color: #666666;
  }
}

.wechaStitle {
  margin-bottom: 15px;
  color: #ff8080;
  font-size: 14px;
  display: flex;
  align-items: center;
}

.wechatAction {
  /deep/.el-button {
    text-decoration: underline;
  }
}

.img-box {
  margin-bottom: 20px;

  // 图片
  .imgs-num {
    text-align: center;
    margin: 5px 0;
    font-weight: bold;
  }

  .img-tips-box {
    display: flex;
    height: 30px;
    width: max-content;
    border: 1px solid #0981ff;

    .img-tips {
      width: 80px;
      text-align: center;
      line-height: 30px;
      box-sizing: border-box;
      cursor: pointer;
    }

    .img-tips-default {
      background: #fff;
      color: #0981ff;
    }

    .img-tips-choose {
      background: #0981ff;
      color: #fff;
    }
  }

  // 列表
}

.sec_img {
  width: 20vw;
  height: 80vh;
  margin: auto;

  img {
    width: 20vw;
    height: 80vh;
    object-fit: contain;
  }
}
</style>
